import React from 'react';
import { FileText, MessageSquare, TrendingUp, Plus, Mail } from 'lucide-react';
import StatCard from './StatCard';

const OverviewTab = ({ stats, onCreatePost, onViewContacts }) => {
  if (!stats) return null;

  return (
    <div className="space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard 
          icon={FileText} 
          label="Total Blog Posts" 
          value={stats.total_blog_posts}
          subValue={`${stats.published_blog_posts} published`}
          color="bg-teal-500"
        />
        <StatCard 
          icon={TrendingUp} 
          label="Published Posts" 
          value={stats.published_blog_posts}
          color="bg-green-500"
        />
        <StatCard 
          icon={MessageSquare} 
          label="Contact Messages" 
          value={stats.total_contacts}
          subValue={`${stats.recent_contacts} this week`}
          color="bg-blue-500"
        />
        <StatCard 
          icon={Mail} 
          label="Recent Inquiries" 
          value={stats.recent_contacts}
          subValue="Last 7 days"
          color="bg-amber-500"
        />
      </div>

      {/* Quick Actions */}
      <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
        <h2 className="text-lg font-semibold text-gray-800 mb-4">Quick Actions</h2>
        <div className="flex gap-4">
          <button
            onClick={onCreatePost}
            className="flex items-center gap-2 px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors"
            data-testid="quick-add-post-btn"
          >
            <Plus className="w-4 h-4" />
            New Blog Post
          </button>
          <button
            onClick={onViewContacts}
            className="flex items-center gap-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
            data-testid="quick-view-contacts-btn"
          >
            <MessageSquare className="w-4 h-4" />
            View Messages
          </button>
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;
